// local columns
import categoryColumn from '../columns/category.column';
import descriptionColumn from '../columns/description.column';
import nameColumn from '../columns/name.column';

const generateColumns = () => [nameColumn, categoryColumn, descriptionColumn];

export default generateColumns;
